<template>
 <div>
   <p class="request-name">{{lang[0]}}</p>
    <div v-if="ideas.length > 0">
      <div
        v-for="(val, index) in ideas"
        :key="index"
        class="idea-wrapper"
        @click="ideaModal(val)"
       >
      <p>
        {{lang[1]}}: {{ val.price }}{{lang[2]}}
      </p>
      <p>
        {{lang[3]}}: {{ val.state ? lang[5] : lang[6]}}
      </p>
    </div>
  </div>
  <div v-else>
    <p>{{lang[4]}}</p>
  </div>
 </div>
</template>

<script>
import axios from 'axios'
import RequestPhase0LangMaster from '../masters/langMaster/RequestPhase0LangMaster'

export default {
  name: 'RequestPhase0',

  /*data(){
    return {
      isIdeaCheck:false,
      modalVal:{},
      modalUser:{},
      loading:true,
    };
  },*/

  props:[
     'ideas'
  ],

  data() {
    return {
      lang: RequestPhase0LangMaster[this.$store.state.account.lang],
    }
  },

  methods: {
    ideaModal(val) {
      this.$parent.loading = true
      axios.get(`private/user_id/${val.saler_id}`)
      .then((data) => {
         this.$parent.isIdeaCheck = true
         this.$parent.modalVal = val
         this.$parent.modalUser = data.data.user
         this.$parent.loading = false
      }).catch((err) => {
         console.log(err)
         this.$parent.loading = false
        })
     },
   },
 }
</script>

<style scoped>

.request-name {
 font-size: 18px;
 font-weight: bold;
}

.idea-wrapper {
  margin: 20px;
  border-radius: 10px;
  background: #F39939;
  padding: 10px;
  color: #fff;
}

.idea-wrapper p {
  margin-bottom: 0.4rem;
}

@media screen and (min-width: 800px){

  .request-name {
    font-size: 20px;
  }

}
</style>
